import { FincasPlataformaService } from "../../../shared/generated/grpc/plataforma_terceros_fincas_pb";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";

/**
 * Baja de la FINCA, desde el mapa global (`FincasPlataformaService.EliminarFinca`, gRPC). El servidor solo la
 * permite si la finca no tiene ningún cliente y no tiene datos; si no, responde con el motivo (`ValidationError`).
 * Su área queda libre para registrar otra finca. Idempotente.
 */
export class FincaEliminarService {
  static readonly instance = new FincaEliminarService();
  private constructor() { }

  /** Da de baja la finca. */
  async eliminar(fincaId: string): Promise<void> {
    await grpcCall(() => grpcClient(FincasPlataformaService).eliminarFinca({ fincaId }));
  }
}
